import * as types from '../constants/actionTypes';

export function approveHours({status, data} = {}) {
    return {
        type: types.APPROVE_HOURS,
        status,
        data
    };
}
export function cmlmLoadApprovedHoursWeek({week, status, data} = {}) {
    return {
        type: types.CM_LM_LOAD_APPROVED_HOURS_WEEK
        , week
        , status
        , data
    };
}
export function countUnapprovedHoursWeek({status, data} = {}) {
    return {
        type: types.COUNT_UNAPPROVED_HOURS_WEEK
        , status
        , data
    };
}
export function createApprovedHours({approvedHours, status, data} = {}) {
    return {
        type: types.CREATE_APPROVED_HOURS
        , approvedHours
        , status
        , data
    };
}
export function pmoLoadApprovableHours({status, data} = {}) {
    return {
        type: types.PMO_LOAD_APPROVABLE_HOURS
        , status
        , data
    };
}
export function setLoadingFlagForApprovedHourState() {
    return { type: types.SET_LOADING_FLAG_FOR_APPROVED_HOUR_STATE };
}
export function setCurrentApprovalWeek(week) {
  return { type: types.SET_CURRENT_APPROVAL_WEEK, week: week };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/approvedHourActions.js
 **/